<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
  <tui-breadcrumbs [itemsLimit]="10">
    <ng-container *ngFor="let item of breadcrumbs; let last = last; let i = index">
      <ng-container *ngIf="last">
        <strong *tuiItem tuiFade>
          {{ item }}
        </strong>
      </ng-container>
      <ng-container *ngIf="!last">
        <button *tuiItem tuiLink type="button" (click)="navigateTo(i)">
          {{ item }}
        </button>
      </ng-container>
    </ng-container>
  </tui-breadcrumbs>
</nav>

<section>
  <div class="mt-5 relative">
    <div *ngIf="!isLoading" class="w-full bg-[#E5EDFF] h-[124px] rounded-t-xl flex items-center justify-end">
      <div class="h-[32px] w-[65px] rounded-full flex items-center justify-center mr-8"
        [style.background-color]="client?.active ? '#6BC68A' : '#FF6B6B'">
        <p class="text-[#FFFFFF] text-sm font-bold">
          {{ client?.active ? "Active" : "Inactive" }}
        </p>
      </div>
    </div>

    <div class="w-full h-[124px] flex items-center">
      <div class="flex items-start justify-between w-full">
        <div>
          <div class="flex items-center space-x-3">
            <!-- <div *ngIf="!isLoading"
              class="w-[17px] h-[17px] rounded-full"
              [style.background-color]="client?.active ? '#52D3C4' : '#FF6B6B'"
            ></div> -->
            <p class="text-2xl font-bold m-0 text-[#000000A6]">
              {{ client?.guardianName
              }}<span class="text-[#526ED3] text-base font-medium">
                {{ getClientIdentifier(client) }}</span>
            </p>
          </div>
          <p class="text-[#6B6D80] text-sm font-medium m-0 pt-2">
            {{ getOnboardingLabel(client) }}
          </p>
        </div>
        <button appearance="flat" class="border custom-icon-button" iconStart="@tui.ellipsis-vertical" tuiIconButton
          type="button" [tuiAppearanceState]="open ? 'hover' : null" [tuiDropdown]="content" [(tuiDropdownOpen)]="open"
          [appDisableUnlessPermission]="'CLIENT_UPDATE'">
          Open
        </button>

        <ng-template #content>
          <tui-data-list tuiDataListDropdownManager [size]="size">
            <button *ngIf="!client.archived" tuiOption type="button" class="dropdown-button"
              [routerLink]="['/admin/client/add-edit/', client._id]"
              [queryParams]="{ returnUrl: '/admin/client/' + client._id }"
              [appDisableUnlessPermission]="'CLIENT_UPDATE'">
              Edit
            </button>
            <button tuiOption type="button" class="dropdown-button" (click)="resetUserPassword(client?.email)"
              [appDisableUnlessPermission]="'CLIENT_UPDATE'">
              Reset Password
            </button>
            <button tuiOption type="button" class="dropdown-button" (click)="toggleActive()"
              [appDisableUnlessPermission]="'CLIENT_UPDATE'">
              {{ client?.active ? "Deactivate" : "Activate" }}
            </button>
            <button *ngIf="!client?.archived || canUnarchiveClient(client)" tuiOption type="button"
              class="dropdown-button" (click)="toggleArchive()" [appDisableUnlessPermission]="'CLIENT_UPDATE'">
              {{ client?.archived ? "Unarchive" : "Archive" }}
            </button>
            <button *ngIf="!client?.archived" tuiOption type="button" class="dropdown-button"
              (click)="openChangeClientType()" [appDisableUnlessPermission]="'CLIENT_UPDATE'">
              Change client type
            </button>
          </tui-data-list>
        </ng-template>
      </div>
    </div>
    <!-- <div class="w-[180px] h-[180px] rounded-full absolute top-10 left-10">
      <img
        class="object-cover w-full h-full rounded-full"
        src="{{ client?.profilePic }} "
        alt=""
      />
    </div> -->
  </div>
  <tui-tabs [(activeItemIndex)]="activeItemIndex" class="gap-5">
    <button tuiTab type="button">Client Profile</button>

    <button tuiTab type="button">Shifts</button>
    <button tuiTab type="button">Charges</button>
    <button tuiTab type="button">Renewal History</button>
  </tui-tabs>
  <div class="mt-10" *ngIf="activeItemIndex === 0">

    <!-- PERSONAL INFORMATION SECTION -->
    
    <div class="flex mb-10">
      <!-- Sidebar Label -->
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Client Information</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View Client information</p>
      </div>

      <!-- Data Column -->
      <div class="flex-1 space-y-6">
        <!-- Logic for Registered/Unregistered/Inward remains the same, but with cleaner spacing -->
        <ng-container *ngIf="isRegistered">
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Registration Number</p>
            <p class="text-[#526ED3] text-xl font-bold m-0">{{ getClientIdentifier(client) || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Registration Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.registrationDate | date : "MMM d, y") ||
              '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Registration Type</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ getRegistrationTypeLabel(client) || '-' }}</p>
          </div>
          <div *ngIf="client?.registrationFee !== null && client?.registrationFee !== undefined">
            <p class="text-sm text-[#595959] font-medium m-0">Registration Fee</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">LKR {{ client?.registrationFee | number : "1.2-2" }}
            </p>
          </div>
          <ng-container *ngIf="isOneYearRegistered">
            <div>
              <p class="text-sm text-[#595959] font-medium m-0">Renewal Date</p>
              <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">
                {{ (client?.renewalDate | date : "MMM d, y") || "—" }}
              </p>
            </div>
            <div>
              <p class="text-sm text-[#595959] font-medium m-0">Expiry Date</p>
              <p class="text-xl font-semibold m-0" [ngClass]="{
                'text-red-600': membershipStatus === 'expired',
                'text-orange-600': membershipStatus === 'expiring',
                'text-[#1B1F3BA6]': membershipStatus === 'active'
              }">
                {{ (client?.expiryDate | date : "MMM d, y") || "—" }}
              </p>
              <span *ngIf="membershipStatus === 'expired'"
                class="inline-block mt-1 text-xs font-semibold text-white bg-red-600 px-2 py-0.5 rounded-full">Expired</span>
              <span *ngIf="membershipStatus === 'expiring'"
                class="inline-block mt-1 text-xs font-semibold text-white bg-orange-500 px-2 py-0.5 rounded-full">Expiring
                soon</span>
              <span *ngIf="membershipStatus === 'active'"
                class="inline-block mt-1 text-xs font-semibold text-white bg-[#6BC68A] px-2 py-0.5 rounded-full">Active
                membership</span>
            </div>
          </ng-container>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Client Name</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianName || '-' }}</p>
          </div>
          <div *ngIf="client?.email">
            <p class="text-sm text-[#595959] font-medium m-0">Email Address</p>
            <p class="text-[#285CA5] text-xl font-bold m-0">{{ client?.email }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Phone Number (Whatsapp)</p>
            <p class="text-[#285CA5] text-xl font-semibold m-0">{{ client?.guardianContactNo || '-' }}</p>
          </div>
          <div *ngIf="client?.guardianNIC">
            <p class="text-sm text-[#595959] font-medium m-0">NIC Number</p>
            <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.guardianNIC }}</p>
          </div>
          <div *ngIf="client?.guardianAddress">
            <p class="text-sm text-[#595959] font-medium m-0">Address</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianAddress }}</p>
          </div>

        </ng-container>

        <ng-container *ngIf="isUnregistered">
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Non Registered Number</p>
            <p class="text-[#526ED3] text-xl font-bold m-0">{{ getClientIdentifier(client) || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Starting Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.startingDate | date : "MMM d, y") || '-'
              }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Client Name</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianName || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Email Address</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.email || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Phone Number (Whatsapp)</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianContactNo || '-' }}</p>
          </div>

          <div *ngIf="client?.guardianNIC">
            <p class="text-sm text-[#595959] font-medium m-0">NIC Number</p>
            <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.guardianNIC }}</p>
          </div>
          <div *ngIf="client?.guardianAddress">
            <p class="text-sm text-[#595959] font-medium m-0">Address</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianAddress }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Nursing Type</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ getRegistrationTypeLabel(client) || '-' }}</p>
          </div>
        </ng-container>

        <ng-container *ngIf="isInward">
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">BHT Number</p>
            <p class="text-[#526ED3] text-xl font-bold m-0">{{ getClientIdentifier(client) || '-' }}</p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Name</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.name || '-' }}
            </p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium m-0">Phone Number (Whatsapp)</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ client?.guardianContactNo || "-" }}</p>
          </div>
           <div>
            <p class="text-sm text-[#595959] font-medium m-0">Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.inwardDate | date : "MMM d, y") || "-" }}</p>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="flex mb-10">
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Patient Information</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View Patient Information</p>
      </div>

      <div class="flex-1 space-y-6">
        <div>
          <p class="text-sm text-[#595959] font-medium m-0">Name</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.name || '-' }}</p>
        </div>
        <div *ngIf="isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Room Number</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.roomNumber || '-' }}</p>
        </div>
        <div *ngIf="isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Meal Type</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.meal || '-' }}</p>
        </div>
        <div *ngIf="isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Roaster</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold m-0">{{ client?.roster || '-' }}</p>
        </div>
        <div *ngIf="!isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Date of Birth</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ (client?.dateOfBirth | date : "MMM d, y") || '-' }}
          </p>
        </div>
        <div *ngIf="!isInward">
          <p class="text-sm text-[#595959] font-medium m-0">Age</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold m-0">{{ formatAge(client) }}</p>
        </div>
      </div>
    </div>


    <div class="flex mb-10" *ngIf="isRegistered || isUnregistered">
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Current Condition</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View Condition</p>
      </div>
      <div class="flex-1">
        <div style="background-color: white;border: 1px solid rgb(197, 194, 194);padding:10px;border-radius: 8px;">
          <p class="text-[0.938rem] text-[#1B1F3BA6] font-medium m-0 leading-relaxed">
            {{ client?.currentCondition || '-' }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex mb-10">
      <div class="w-[250px] shrink-0">
        <p class="text-base font-medium text-[#3E4A58] m-0">Current Location</p>
        <p class="text-sm font-semibold text-[#949494D9] m-0">View the patient location</p>
      </div>
      <div class="flex-1">
        <div style="background-color: white;border: 1px solid rgb(197, 194, 194);padding:10px;border-radius: 8px;">
          <p class="text-[0.938rem] text-[#1B1F3BA6] font-medium m-0 leading-relaxed">
            {{ client?.currentLocation || '-' }}
          </p>
        </div>
      </div>
    </div>


  </div>

  <!-- <div class="mt-10" *ngIf="activeItemIndex === 0">
    <div class="flex">
      <div class="inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0">
          Personal Information
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0">
          View Client information
        </p>
      </div>
      <div class="inline-block pl-[5.5rem]">
        <ng-container *ngIf="isRegistered">
          <div>
            <p class="text-sm text-[#595959] font-medium my-0">
              Registration Number
            </p>
            <p class="text-[#526ED3] text-xl font-bold my-0">
              {{ getClientIdentifier(client) }}
            </p>
          </div>
          <div class="pt-5">
            <p class="text-sm text-[#595959] font-medium my-0">Date of Birth</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ client?.dateOfBirth | date : "MMM d, y" }}
            </p>
          </div>
          <div class="pt-5">
            <p class="text-sm text-[#595959] font-medium my-0">Age</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ formatAge(client) }}
            </p>
          </div>
          <div class="pt-5">
            <p class="text-sm text-[#595959] font-medium my-0">
              Registration Type
            </p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ getRegistrationTypeLabel(client) }}
            </p>
          </div>
          <div
            class="pt-5"
            *ngIf="
              client?.registrationType &&
              client?.registrationType !== 'Life Time' &&
              client?.expiryDate
            "
          >
            <p class="text-sm text-[#595959] font-medium my-0">Expiry Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ client?.expiryDate | date : "MMM d, y" }}
            </p>
          </div>
        </ng-container>


        <ng-container *ngIf="isUnregistered">
          <div>
            <p class="text-sm text-[#595959] font-medium my-0">
              Non Registered Number
            </p>
            <p class="text-[#526ED3] text-xl font-bold my-0">
              {{ getClientIdentifier(client) }}
            </p>
          </div>
          <div class="pt-5">
            <p class="text-sm text-[#595959] font-medium my-0">Starting Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ client?.startingDate | date : "MMM d, y" }}
            </p>
          </div>
          <div class="pt-5" *ngIf="client?.age || client?.ageMonths">
            <p class="text-sm text-[#595959] font-medium my-0">Age</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ formatAge(client) }}
            </p>
          </div>
          <div class="pt-5">
            <p class="text-sm text-[#595959] font-medium my-0">Nursing Type</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ getRegistrationTypeLabel(client) }}
            </p>
          </div>
        </ng-container>


        <ng-container *ngIf="isInward">
          <div>
            <p class="text-sm text-[#595959] font-medium my-0">BHT Number</p>
            <p class="text-[#526ED3] text-xl font-bold my-0">
              {{ getClientIdentifier(client) }}
            </p>
          </div>
          <div class="pt-5">
            <p class="text-sm text-[#595959] font-medium my-0">Inward Date</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ client?.inwardDate | date : "MMM d, y" }}
            </p>
          </div>
          <div class="pt-5" *ngIf="client?.roomNumber">
            <p class="text-sm text-[#595959] font-medium my-0">Room Number</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ client?.roomNumber }}
            </p>
          </div>
          <div class="pt-5" *ngIf="client?.meal">
            <p class="text-sm text-[#595959] font-medium my-0">Meal</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ client?.meal }}
            </p>
          </div>
          <div class="pt-5" *ngIf="client?.roster">
            <p class="text-sm text-[#595959] font-medium my-0">Roster</p>
            <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
              {{ client?.roster }}
            </p>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="flex mt-5">
      <div class="inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0">
          Client Details
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0">
          View Contact Person
        </p>
      </div>
      <div class="inline-block pl-[7.5rem]">
        <div>
          <p class="text-sm text-[#595959] font-medium my-0">Name</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold my-0">
            {{ client?.guardianName }}
          </p>
        </div>
        <div class="pt-5" *ngIf="isRegistered">
          <p class="text-sm text-[#595959] font-medium my-0">NIC Number</p>
          <p class="text-[#1B1F3BA6] text-xl font-bold my-0">
            {{ client?.guardianNIC }}
          </p>
        </div>
        <div class="pt-5" *ngIf="isRegistered && client?.email">
          <p class="text-sm text-[#595959] font-medium my-0">Email Address</p>
          <p class="text-[#285CA5] text-xl font-bold my-0">
            {{ client?.email }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">
            Phone Number (Whatsapp)
          </p>
          <p class="text-[#285CA5] text-xl font-semibold my-0">
            {{ client?.guardianContactNo }}
          </p>
        </div>
        <div class="pt-5" *ngIf="client?.guardianAddress">
          <p class="text-sm text-[#595959] font-medium my-0">Address</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ client?.guardianAddress }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex mt-8" *ngIf="isRegistered">
      <div class="inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0 w-[200px]">
          Current Condition
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0 w-[200px]">
          View Condition of the patient
        </p>
      </div>
      <div class="inline-block pl-[45px] lg:pl-[3rem]">
        <div
          style="border: 1px solid #d1d5db; border-radius: 6px; padding: 16px"
        >
          <p
            class="text-[0.938rem] text-[#1B1F3BA6] font-medium my-0 w-full md:w-full lg:w-full xl:w-[760px] 2xl:w-[960px] h-full"
          >
            {{ client?.currentCondition }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex mt-8" *ngIf="isRegistered">
      <div class="inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0 w-[170px]">
          Current Location
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0 w-[170px]">
          View the patient location
        </p>
      </div>
      <div class="inline-block pl-[70px] lg:pl-[5rem] 2xl:pl-[5rem]">
        <div
          style="border: 1px solid #d1d5db; border-radius: 6px; padding: 16px"
        >
          <p
            class="text-[0.938rem] text-[#1B1F3BA6] font-medium my-0 w-full md:w-full lg:w-full xl:w-[760px] 2xl:w-[960px] h-full"
          >
            {{ client?.currentLocation }}
          </p>
        </div>
      </div>
    </div>
  </div> -->
  <div class="mt-10" *ngIf="activeItemIndex === 1">
    <search class="lg:w-[50%] xl:w-[50%] 2xl:w-[40%] mb-5" tuiSearch style="padding-left: 0">
      <fieldset class="border-none" tuiTextfieldSize="m" style="padding-left: 0">
        <div class="flex items-center space-x-4">
          <div class="w-[431px]">
            <tui-input-date-range [(ngModel)]="dateRange" tuiUnfinishedValidator="Finish filling the field">
              Date range filter
            </tui-input-date-range>
          </div>
          <button size="m" tuiButton type="button" (click)="onFilter()" style="padding-left: 40px; padding-right: 40px">
            Filter
          </button>

          <button type="button" tuiButton appearance="outline" (click)="resetFilter()">
            Reset Filter
          </button>
        </div>
      </fieldset>
    </search>
    <div *ngIf="shifts.length == 0">
      <p class="text-base font-medium text-[#3E4A58]">
        Attendance Unavailable!
      </p>
    </div>
    <div class="flex">
      <div *ngIf="shifts.length > 0" class="w-full">
        <table tuiTable size="m" class="w-full">
          <thead>
            <tr></tr>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Date
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Nurse name
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Roster
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Meal Option
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Type
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Address
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Charges
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let shift of shifts">
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm cursor-pointer">
                    {{ getFormattedDate(shift.date) }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.nurse[0].name }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.rooster }} Hour
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.mealOption }}</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.shiftType }}</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{
                    (shift.address?.length || 0) > 20
                    ? (shift.address | slice : 0 : 40) + "..."
                    : shift.address
                    }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    LKR {{ shift.charges | number : "1.2-2" }}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="flex justify-end items-center mt-5">
          <tui-pagination [index]="shiftPageIndex - 1" [length]="getShiftPageCount()"
            (indexChange)="onShiftPageChange($event + 1)">
          </tui-pagination>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5" *ngIf="activeItemIndex === 2">
    <div *ngIf="chargesRecords.length == 0">
      <p class="text-base font-medium text-[#3E4A58]">Charges Unavailable!</p>
    </div>

    <div *ngIf="chargesRecords.length > 0" class="flex">
      <div class="w-full xl:w-1/3 2xl:w-full">
        <table tuiTable size="m" class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Month
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                No of Shifts
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                No of Extras
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Total Charges
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Actions
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let chargesRecord of chargesRecords">
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm cursor-pointer">
                    {{ chargesRecord.monthName}} - {{ chargesRecord.year }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ chargesRecord.shiftCount }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ chargesRecord.procedureCount }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ chargesRecord.totalCharges | number : "1.2-2" }} LKR
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
                    (click)="
                      viewChargesDetails(
                        clientId,
                        chargesRecord.month,
                        chargesRecord.year
                      )
                    ">
                    View Details
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="flex justify-start items-center mt-5 ml-[300px] md:ml-[570px] lg:ml-[450px] xl:ml-[690px] 2xl:ml-[970px]">
          <tui-pagination [index]="chargesPageIndex - 1" [length]="getChargesPageCount()"
            (indexChange)="onChargesPageChange($event + 1)">
          </tui-pagination>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-5" *ngIf="activeItemIndex === 3">
    <div class="mb-10" *ngIf="isOneYearRegistered">
      <div class="flex items-start justify-between mb-4">
        <div>
          <p class="text-base font-medium text-[#3E4A58] m-0">Renewal History</p>
          <p class="text-sm font-semibold text-[#949494D9] m-0">
            Past renewal records for this client
          </p>
        </div>
        <button appearance="primary" tuiButton type="button" size="s" [disabled]="client?.archived || renewBusy"
          (click)="openRenewDialog()" [appDisableUnlessPermission]="'CLIENT_UPDATE'">
          Record renewal
        </button>
      </div>

      <div *ngIf="sortedRenewalFees.length === 0"
        class="text-center py-8 border border-dashed border-gray-300 rounded-lg">
        <p class="text-gray-600 mb-3">No renewals recorded yet.</p>
        <button appearance="primary" tuiButton type="button" size="s" [disabled]="client?.archived"
          (click)="openRenewDialog()" [appDisableUnlessPermission]="'CLIENT_UPDATE'">
          Record first renewal
        </button>
      </div>

      <div *ngIf="sortedRenewalFees.length > 0" class="overflow-x-auto">
        <table tuiTable class="w-full min-w-[900px]">
          <thead>
            <tr>
              <th tuiTh>#</th>
              <th tuiTh>Renewal date</th>
              <th tuiTh>Fee (LKR)</th>
              <th tuiTh>Valid until</th>
              <th tuiTh>Recorded</th>
              <th tuiTh>By</th>
              <th tuiTh>Notes</th>
              <th tuiTh>Actions</th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let row of sortedRenewalFees; let i = index" [class.bg-blue-50]="isCurrentRenewalRow(row)">
              <td tuiTd>{{ i + 1 }}</td>
              <td tuiTd>{{ row.date | date : "MMM d, y" }}</td>
              <td tuiTd>{{ row.fee | number : "1.2-2" }}</td>
              <td tuiTd>
                {{ row.periodEnd ? (row.periodEnd | date : "MMM d, y") : "—" }}
              </td>
              <td tuiTd>
                {{ row.recordedAt ? (row.recordedAt | date : "MMM d, y") : "—" }}
              </td>
              <td tuiTd>{{ recordedByName(row) }}</td>
              <td tuiTd>{{ row.notes || "—" }}</td>
              <td tuiTd>
                <button appearance="flat" size="xs" tuiButton type="button" [disabled]="!canEditRenewalRow(row)"
                  (click)="openEditRenewalDialog(row)" [appDisableUnlessPermission]="'CLIENT_UPDATE'">
                  Edit
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<app-change-client-type-panel [open]="changeTypeDialogOpen" [client]="client" [busy]="changeTypeBusy"
  (openChange)="changeTypeDialogOpen = $event" (confirm)="onChangeTypeConfirm($event)"
  (cancel)="onChangeTypeCancel()" />

<app-record-renewal-dialog [open]="renewDialogOpen" [client]="client" [editRecord]="editRenewalRecord"
  [busy]="renewBusy" (openChange)="onRenewDialogOpenChange($event)" (confirm)="onRenewConfirm($event)" />